export default class ValidationUtility {

  static isNotEmptyText(value: string): boolean
  {
    return value.length > 0;
  }

  static isValidTextDigits(value: string): boolean
  {
    return /^[0-9]*$/.test(value);
  }

  static isValidTextEn(value: string): boolean
  {
    return /^[\x20-\x7e]*$/.test(value);
  }

  static isValidTextKana(value: string): boolean
  {
    return /^[ぁ-んー]*$/.test(value);
  }
}
